import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const ROLES = {
  ADMIN: 34,
  ASSIGNEE: 37,
  BILLING_CONTACT: 41,
  EDITOR: 35,
  OWNER: 38,
  STEALTH_WATCHER: 39,
  TEMP: 36,
  WATCHER: 40,
};

export const ROLE = {
  ROLES,
};

export default ShModel.extend({
    name: attr(),
    description: attr(),
    isOwner: attr('Boolean')
});
